import { render } from "./MoneyFormat.vue?vue&type=template&id=07070b3e"
import script from "./MoneyFormat.vue?vue&type=script&lang=js"
export * from "./MoneyFormat.vue?vue&type=script&lang=js"

import "./MoneyFormat.vue?vue&type=style&index=0&id=07070b3e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__